module.exports = __webpack_public_path__ + "img/lepricon_icon.a8d58b9d.png";